
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/packages-curateur",
      function () {
        return require("private-next-pages/packages-curateur.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/packages-curateur"])
      });
    }
  